<script setup>
import { useSettingsStore } from './settings/stores/settings';

// Get the settings store
const settingsStore = useSettingsStore();
</script>

<template>
  <div>
    <div
      v-for="(notice, index) in settingsStore.notices"
      :key="notice.id || index"
      class="notice da:p-4 da:my-4 da:flex da:items-center da:justify-between da:relative"
      :class="{
        'notice-success da:bg-green-100 da:text-green-800 da:border-l-4 da:border-green-500': notice.type === 'success',
        'notice-error da:bg-red-100 da:text-red-800 da:border-l-4 da:border-red-500': notice.type === 'error',
        'notice-info da:bg-blue-100 da:text-blue-800 da:border-l-4 da:border-blue-500': notice.type === 'info',
      }"
    >
      <p v-html="notice.message" class="da:m-0"></p>
      <button
        class="notice-dismiss da:text-sm da:font-medium da:focus:outline-none"
        @click="settingsStore.removeNotice(notice.id)"
      >
        <span class="screen-reader-text">Dismiss this notice</span>
      </button>
    </div>
  </div>
</template>
